export const SESSION_ERROR_CODES = {
	SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
	ACCESS_TOKEN_MISSING: 'ACCESS_TOKEN_MISSING',
	VALIDATION_ERROR: 'VALIDATION_ERROR',
	UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export type SessionErrorCode = typeof SESSION_ERROR_CODES[keyof typeof SESSION_ERROR_CODES];

export const SESSION_ERROR_CODE_TO_TRANSLATION_KEY: Record<string, string> = {
	[SESSION_ERROR_CODES.SERVICE_UNAVAILABLE]: 'api:appSessionService:session:serviceUnavailable',
	[SESSION_ERROR_CODES.ACCESS_TOKEN_MISSING]: 'api:appSessionService:session:accessTokenMissing',
	[SESSION_ERROR_CODES.VALIDATION_ERROR]: 'api:appSessionService:session:validationError',
	[SESSION_ERROR_CODES.UNKNOWN_ERROR]: 'api:appSessionService:session:unknownError',
};

export const PREAUTH_ERROR_CODES = {
	ACCESS_TOKEN_MISSING: 'ACCESS_TOKEN_MISSING',
	SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
	CAPTCHA_FAILED: 'CAPTCHA_FAILED',
	UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export type PreAuthErrorCode = typeof PREAUTH_ERROR_CODES[keyof typeof PREAUTH_ERROR_CODES];

export const PREAUTH_ERROR_CODE_TO_TRANSLATION_KEY: Record<string, string> = {
	[PREAUTH_ERROR_CODES.ACCESS_TOKEN_MISSING]: 'api:preAuthService:authorize:accessTokenMissing',
	[PREAUTH_ERROR_CODES.SERVICE_UNAVAILABLE]: 'api:preAuthService:authorize:serviceUnavailable',
	[PREAUTH_ERROR_CODES.CAPTCHA_FAILED]: 'api:preAuthService:authorize:captchaFailed',
	[PREAUTH_ERROR_CODES.UNKNOWN_ERROR]: 'api:preAuthService:authorize:unknownError',
};

export const ASSIGN_TICKET_ERROR_CODES = {
	USER_SESSION_INVALID_TICKET: 'USER_SESSION_INVALID_TICKET',
	PAYMENT_FAILED: 'PAYMENT_FAILED',
	VALIDATION_ERROR: 'VALIDATION_ERROR',
	CAPTCHA_FAILED: 'CAPTCHA_FAILED',
	ACCESS_TOKEN_MISSING: 'ACCESS_TOKEN_MISSING',
	STORE_NOT_FOUND: 'STORE_NOT_FOUND',
	USER_SESSION_NOT_FOUND: 'USER_SESSION_NOT_FOUND',
	TICKET_NOT_FOUND: 'TICKET_NOT_FOUND',
	SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
	UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export type AssignTicketErrorCode = typeof ASSIGN_TICKET_ERROR_CODES[keyof typeof ASSIGN_TICKET_ERROR_CODES];

export const ASSIGN_TICKET_ERROR_CODE_TO_TRANSLATION_KEY: Record<string, string> = {
	[ASSIGN_TICKET_ERROR_CODES.USER_SESSION_INVALID_TICKET]: 'api:appSessionService:assignTicket:userSessionInvalidTicket',
	[ASSIGN_TICKET_ERROR_CODES.PAYMENT_FAILED]: 'api:appSessionService:assignTicket:paymentFailed',
	[ASSIGN_TICKET_ERROR_CODES.VALIDATION_ERROR]: 'api:appSessionService:assignTicket:validationError',
	[ASSIGN_TICKET_ERROR_CODES.CAPTCHA_FAILED]: 'api:appSessionService:assignTicket:captchaFailed',
	[ASSIGN_TICKET_ERROR_CODES.ACCESS_TOKEN_MISSING]: 'api:appSessionService:assignTicket:accessTokenMissing',
	[ASSIGN_TICKET_ERROR_CODES.STORE_NOT_FOUND]: 'api:appSessionService:assignTicket:storeNotFound',
	[ASSIGN_TICKET_ERROR_CODES.USER_SESSION_NOT_FOUND]: 'api:appSessionService:assignTicket:userSessionNotFound',
	[ASSIGN_TICKET_ERROR_CODES.TICKET_NOT_FOUND]: 'api:appSessionService:assignTicket:ticketNotFound',
	[ASSIGN_TICKET_ERROR_CODES.SERVICE_UNAVAILABLE]: 'api:appSessionService:assignTicket:serviceUnavailable',
	[ASSIGN_TICKET_ERROR_CODES.UNKNOWN_ERROR]: 'api:appSessionService:assignTicket:unknownError',
};

export const PLACE_ORDER_ERROR_CODES = {
	USER_SESSION_INVALID_TICKET: 'USER_SESSION_INVALID_TICKET',
	BAD_PAYMENT: 'BAD_PAYMENT',
	PAYMENT_FAILED: 'PAYMENT_FAILED',
	VALIDATION_ERROR: 'VALIDATION_ERROR',
	CAPTCHA_FAILED: 'CAPTCHA_FAILED',
	ACCESS_TOKEN_MISSING: 'ACCESS_TOKEN_MISSING',
	STORE_NOT_FOUND: 'STORE_NOT_FOUND',
	USER_SESSION_NOT_FOUND: 'USER_SESSION_NOT_FOUND',
	TICKET_NOT_CREATED: 'TICKET_NOT_CREATED',
	TICKET_NOT_FOUND: 'TICKET_NOT_FOUND',
	SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
	INPUT_VALIDATION_ERROR: 'INPUT_VALIDATION_ERROR',
	TRANSACTION_FAILED: 'TRANSACTION_FAILED',
	UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export type PlaceOrderErrorCode = typeof PLACE_ORDER_ERROR_CODES[keyof typeof PLACE_ORDER_ERROR_CODES];

export const PLACE_ORDER_ERROR_CODE_TO_TRANSLATION_KEY: Record<string, string> = {
	[PLACE_ORDER_ERROR_CODES.USER_SESSION_INVALID_TICKET]: 'api:orderService:placeOrder:userSessionInvalidTicket',
	[PLACE_ORDER_ERROR_CODES.BAD_PAYMENT]: 'api:orderService:placeOrder:badPayment',
	[PLACE_ORDER_ERROR_CODES.PAYMENT_FAILED]: 'api:orderService:placeOrder:paymentFailed',
	[PLACE_ORDER_ERROR_CODES.VALIDATION_ERROR]: 'api:orderService:placeOrder:validationError',
	[PLACE_ORDER_ERROR_CODES.CAPTCHA_FAILED]: 'api:orderService:placeOrder:captchaFailed',
	[PLACE_ORDER_ERROR_CODES.ACCESS_TOKEN_MISSING]: 'api:orderService:placeOrder:accessTokenMissing',
	[PLACE_ORDER_ERROR_CODES.STORE_NOT_FOUND]: 'api:orderService:placeOrder:storeNotFound',
	[PLACE_ORDER_ERROR_CODES.USER_SESSION_NOT_FOUND]: 'api:orderService:placeOrder:userSessionNotFound',
	[PLACE_ORDER_ERROR_CODES.TICKET_NOT_CREATED]: 'api:orderService:placeOrder:ticketNotCreated',
	[PLACE_ORDER_ERROR_CODES.TICKET_NOT_FOUND]: 'api:orderService:placeOrder:ticketNotFound',
	[PLACE_ORDER_ERROR_CODES.SERVICE_UNAVAILABLE]: 'api:orderService:placeOrder:serviceUnavailable',
	[PLACE_ORDER_ERROR_CODES.INPUT_VALIDATION_ERROR]: 'api:orderService:placeOrder:inputValidationError',
	[PLACE_ORDER_ERROR_CODES.TRANSACTION_FAILED]: 'api:orderService:placeOrder:transactionFailed',
	[PLACE_ORDER_ERROR_CODES.UNKNOWN_ERROR]: 'api:orderService:placeOrder:unknownError',
};



